import gql from "graphql-tag";

export const CREATE_PRICER = gql`
  mutation AddPricer($data: PricerDataInput) {
    addPricer(data: $data) {
      id
      insurancePlan {
        id
        risk
      }
    }
  }
`;

export const DUPLICATE_PRICER = gql`
  mutation DuplicatePricer($where: PricerWhereInput) {
    duplicatePricer(where: $where) {
      id
      insurancePlan {
        id
      }
    }
  }
`;

export const UPDATE_PRICER = gql`
  mutation UpdatePricer($data: PricerDataInput, $where: PricerWhereInput) {
    updatePricer(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_PRICER = gql`
  mutation DeletePricer($where: PricerWhereInput) {
    deletePricer(where: $where) {
      id
    }
  }
`;

export const VALIDATE_PRICER_IMPORT = gql`
  mutation ValidatePricerImport($data: PricerImportValidateInput) {
    validatePricerImport(data: $data) {
      valid
      errors {
        key
        params
      }
      warnings
      mapping
      autoMapping
      headers
      totalRows
      format
      preview
      columnSamples
      beneficiaryTypes
      fields {
        key
        required
        validation
        geo
      }
    }
  }
`;

export const IMPORT_PRICERS_FROM_FILE = gql`
  mutation ImportPricersFromFile($data: PricerImportExecuteInput) {
    importPricersFromFile(data: $data) {
      success
      pricersCreated
      pricersUpdated
      pricersSkipped
      totalRows
      startDate
      endDate
      strategy
      errors {
        key
        params
      }
    }
  }
`;

const pricers = {
  CREATE_PRICER,
  UPDATE_PRICER,
  DELETE_PRICER,
  DUPLICATE_PRICER,
  VALIDATE_PRICER_IMPORT,
  IMPORT_PRICERS_FROM_FILE,
};

export default pricers;
